<template>
    <div v-if="show"  class="cta-banner">
        <div class="cta-banner__content">
            <base-icon width="34" height="34" name="painel/star" />
            <p>Condições especiais por tempo limitado nos presentes recebidos.</p>
        </div>
        <button type="button" @click="redirectAnalytics">Ver condições</button>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import GiftsApi from '@/lib/api/Gifts'
import Marketing from '../../lib/api/Marketing';

export default {
    name: 'BannerFlexRepass',

    data() {
        return {
            show: false,
        }
    },

    computed: {
        ...mapGetters({
            wedId: 'app/getWedId',
            logonToken: 'app/logonToken'
        })
    },

    mounted() {
        this.getFlexibleRepassEnabled()
    },

    methods: {
        getFlexibleRepassEnabled() {
            const giftsApi = new GiftsApi(this.logonToken)

            giftsApi
                .getTaxes()
                .then((response) => {
                    this.show = response.data.group?.should_show_banner ?? false;
                })
                .catch((error) => console.error(error))
        },

        redirectAnalytics() {
            const marketingAPI = new Marketing(this.logonToken);

            marketingAPI
                .addAnalyticsActivity({ wed_id: this.wedId, target: 'carteira-repasse-flexivel-cta', activity: 'clicked' })
                .catch((error) => console.error(error))
                .finally(() => {
                    this.$router.push('/presentes/configurar-lista')
                })
        }
    },
}
</script>

<style lang="scss">
.cta-banner {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin: 16px 2em 16px 2.5em;
    border: 1px solid #D4DBE3;
    padding: 12px;
    gap: 16px;
    border-radius: 8px;


    @media screen and (max-width: 768px) {
        flex-direction: column;
        gap: 8px;
    }


    &__content {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 16px;


        svg {
            background-color: #FCF3F6;
            border-radius: 8px;
            padding: 7px;
            min-width: 34px;
            min-height: 34px;
        }


        p {
            color: #5D758D;
            font-size: 14px;
            font-weight: 700;
            line-height: 20px;
        }
    }

    button {
        padding: 8px 16px;
        background-color: #ECA3BA;
        border-radius: 100px;
        border: none;
        cursor: pointer;

        font-size: 14px;
        font-weight: 700;
        color: #fff;

        @media screen and (max-width: 768px) {
            width: 100%;
        }
    }
}
</style>
